import React, { useMemo } from "react";
import { Drawer, ActionIcon, createStyles } from "@mantine/core";
import { useDisclosure, useMediaQuery } from "@mantine/hooks";
import { IconMenu2 } from "@tabler/icons-react";
import { useSelector } from "react-redux";
import SideBarNav from "./sideBarNav";
import AccountProvider from "../accountContext";

const useStyles = createStyles(() => ({
  header: {},
  closeButton: {
    top: "1rem",
    right: "1rem",
    position: "absolute",
    "& svg": {
      width: "2rem",
      height: "2rem",
    },
  },
  hide: {
    width: 0,
    height: 0,
    opacity: 0,
    position: "absolute",
    zIndex: -1,
  },
}));
const MobileMenu = ({ userManager }) => {
  const language = useSelector((state) => state.language);
  const [opened, { open, close }] = useDisclosure(false);
  const isMobile = useMediaQuery("(max-width: 768px)");
  const { classes } = useStyles();

  const label = useMemo(() => {
    if (opened) return language.MenuOpened;
    if (!opened) return language.MenuClosed;
  }, [opened, language]);
  return (
    <>
      {isMobile && (
        <AccountProvider>
          <ActionIcon
            aria-label={language.OpenMenu}
            color="dark"
            onClick={open}
          >
            <IconMenu2 />
          </ActionIcon>
          <div role="alert" aria-live="assertive">
            <div className={classes.hide} aria-label={label} />
          </div>
          <Drawer
            opened={opened}
            onClose={close}
            classNames={{
              header: classes.header,
              closeButton: classes.closeButton,
            }}
            closeButtonLabel={language.CloseMenu}
          >
            <div role="alert" aria-live="assertive">
              {opened && <div className={classes.hide} aria-label={label} />}
            </div>
            <SideBarNav
              userManager={userManager}
              drawerOpened={opened}
              drawerClose={close}
            />
          </Drawer>
        </AccountProvider>
      )}
    </>
  );
};

export default MobileMenu;
